import { formatARS, type CashDayDto } from '@gl/shared';
import { cn } from '@/lib/utils';

export function Kpi({
  label,
  value,
  hint,
  className,
}: {
  label: string;
  value: string;
  hint?: string;
  className?: string;
}) {
  return (
    <div className={cn('min-w-0 rounded-xl border bg-card p-3', className)}>
      <p className="truncate text-xs text-muted-foreground">{label}</p>
      <p className="truncate text-lg font-semibold tabular-nums md:text-xl">{value}</p>
      {hint && <p className="truncate text-xs text-muted-foreground">{hint}</p>}
    </div>
  );
}

/** Totales del día de negocio actual. */
export function CashTodaySummary({ data, className }: { data: CashDayDto | undefined; className?: string }) {
  const dash = '—';
  return (
    <div className={cn('grid grid-cols-2 gap-2 md:grid-cols-4', className)}>
      <Kpi
        label="Vendido hoy"
        value={data ? formatARS(data.salesTotalCents) : dash}
        hint={data ? `${data.salesCount} ${data.salesCount === 1 ? 'venta' : 'ventas'}${data.voidedCount ? ` · ${data.voidedCount} anul.` : ''}` : undefined}
      />
      <Kpi
        label="Efectivo del día"
        value={data ? formatARS(data.cashExpectedCents) : dash}
        hint="neto en efectivo"
      />
      <Kpi label="Gastos" value={data ? formatARS(data.expensesTotalCents) : dash} />
      <Kpi
        label="Ticket promedio"
        value={data ? formatARS(data.salesCount ? Math.round(data.salesTotalCents / data.salesCount / 100) * 100 : 0) : dash}
      />
    </div>
  );
}
